//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Emitter from '@/mixins/emitter';
import Tooltip from '@/mixins/tooltip';

export default {
  name: 'DpCheckbox',
  mixins: [
    Emitter,
    Tooltip,
  ],
  props: {
    /**
     * Model
     * @model
     */
    value: { type: Boolean, default: false },
    checked: { type: Boolean, default: null },
    disabled: { type: Boolean, default: false },
    label: { type: [String, Number, Boolean], default: '' },
    val: { type: [String, Number], default: '' },
    block: { type: Boolean, default: false },
    size: { type: String, default: 'default' },
  },
  data() {
    return {
      selfModel: false,
      focus: false,
      trueLabel: null,
    };
  },
  computed: {
    model: {
      get() {
        if (this.isGroup) {
          return this.store;
        }
        return this.value;
      },
      set(val) {
        if (this.isGroup) {
          this.dispatch('DpCheckboxGroup', 'input', [val]);
        } else {
          this.$emit('input', val);
          this.$emit('change', val);
          this.selfModel = val;
        }
      },
    },
    isDisabled() {
      return this.disabled || false;
    },
    isChecked() {
      // Allow checked override
      if (this.checked === true || this.checked === false) {
        return this.checked;
      }
      if ({}.toString.call(this.model) === '[object Boolean]') {
        return this.selfModel;
      } if (Array.isArray(this.model)) {
        return this.model.indexOf(this.val || this.label) > -1;
      } if (this.model !== null && this.model !== undefined) {
        return this.model === this.trueLabel;
      }
      return false;
    },
    isGroup() {
      return !!this.checkboxGroup;
    },
    store() {
      return this.checkboxGroup ? this.checkboxGroup.value : this.value;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.selfModel = val;
      },
    },
  },
  created() {
    let parent = this.$parent;
    while (parent) {
      if (parent.$options.name !== 'DpCheckboxGroup') {
        parent = parent.$parent;
      } else {
        this.checkboxGroup = parent;
        break;
      }
    }

    if (this.checked) {
      this.addToStore();
    }
  },
  methods: {
    addToStore() {
      if (Array.isArray(this.model) && this.model.indexOf(this.val || this.label) === -1) {
        this.model.push(this.val || this.label);
      } else {
        this.model = this.trueLabel || true;
      }
    },
    handleChange() {
      if (this.isGroup) {
        this.dispatch('DpCheckboxGroup', 'change', [this.checkboxGroup.value]);
      }
    },
  },
};
